import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=bf6b7c10&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=bf6b7c10&scoped=true&lang=less&"
import style1 from "./Preview.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6b7c10",
  null
  
)

export default component.exports